import React from "react";
import ReactDOM from 'react-dom';
import Hammer from "react-hammerjs";
import { tapOptions } from '../utils/hammerOptions';

import closeButton from '../assets/btn_close.png'

let privateProps = {
  component: true,
  children: true,
  onRequestClose: true
}


class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Modal';
    this.state = {};
    this._handleClose = this._handleClose.bind(this);
  }

  _handleClose(ev) {
    // only accept taps on the modal background or close button, not on modal foreground
    if (( ev.target === ReactDOM.findDOMNode(this) ) || 
        ( ev.target === ReactDOM.findDOMNode(this.refs.closeButton) )) {
      this.props.onRequestClose();     
    }
  }

  render() {
    let props = {};

    // Pass on any props that aren't privateProps
    Object.keys(this.props).forEach(function(i) {
      if (!privateProps[i]) {
        props[i] = this.props[i];
      }
    }, this);

    let modalContent = React.createElement(this.props.component, props, this.props.children);

    return (
      <Hammer onTap={this._handleClose} options={tapOptions} >
        <div className='modal-container '>
          <div className='modal-content bordered-container'>
            <Hammer onTap={this._handleClose} options={tapOptions} >
              <img className='modal-close-button' src={closeButton} ref='closeButton' /> 
            </Hammer>
            <div className='border full-width'>
            {modalContent}
            </div>
          </div>
        </div>
      </Hammer>
      )
  }
}


Modal.defaultProps = { component: 'span' };

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js